module.exports = __webpack_public_path__ + "img/文字版.9789042f.png";